<shared-checkbox [formControl]="internalControl" [label]="label" [binary]="true" />
